export default {
  RECAPTCHA_KEY: process.env.REACT_APP_KEY_RECAPTCHA,
  RECAPTCHA_KEY_VISIBLE: process.env.REACT_APP_KEY_RECAPTCHA_VISIBLE,
  documents: {
    termsAndConditionsBank: process.env.REACT_APP_URL_TAC_BANK,
    dataPrivacyPolicyBank: process.env.REACT_APP_URL_DP_BANK,
    termsAndConditionsSoyYo: process.env.REACT_APP_URL_TAC_SY,
    dataPrivacyPolicySoyYo: process.env.REACT_APP_URL_DP_SY
  },
  url: {
    URLCREATETRANSACTION: process.env.REACT_APP_URL_CREATE_TRANSACTION,
    URLVALIDATEUSER: process.env.REACT_APP_URL_VALIDATE_USER,
    URLVALIDATEUSERVISIBLE: process.env.REACT_APP_URL_VALIDATE_USER_VISIBLE,
    URLACTIVATEUSER: process.env.REACT_APP_URL_ACTIVATE_USER,
    URLVALIDATETRANSACTION: process.env.REACT_APP_URL_VALIDATE_TRANSACTION,
    URLAUTHORIZATIONCODE: process.env.REACT_APP_URL_AUTHORIZATION_CODE,
    URLLOGS: process.env.REACT_APP_URL_LOGS,
    URLVALIDATETOKEN: process.env.REACT_APP_URL_VALIDATE_TOKEN,
    URLRETRYBIOMETRICS: process.env.REACT_APP_URL_RETRY_BIOMETRICS,
    URLBFPUBLICKEY: process.env.REACT_APP_URL_BF_PUBLIC_KEY,
    URLASYNC: process.env.REACT_APP_URL_ASYNC,
    URLDELIVERRESPONSE: process.env.REACT_APP_URL_DELIVER_RESPONSE,
    URLCLOSESESSION: process.env.REACT_APP_URL_CLOSE_SESSION,
    URLPREVALIDATE: process.env.REACT_APP_URL_PREVALIDATE,
  },
  sdk: {
    API_KEY: process.env.REACT_APP_API_KEY,
    CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
    CLIENT_SECRET: process.env.REACT_APP_CLIENT_SECRET,
    PRODUCTION: process.env.REACT_APP_PRODUCTION,
    ENTITY_ID: process.env.REACT_APP_ENTITY_ID,
    APP_IDENTIFIER: process.env.REACT_APP_IDENTIFIER
  },
  CONSUMERS: process.env.REACT_APP_CONSUMERS_LIST,
  REDIRECT_URLS: process.env.REACT_APP_URL_LIST,
  TEST_MODE: process.env.REACT_APP_TESTMODE,
  SECRET: process.env.REACT_APP_SECRET,
  MAX_ATTEMPS: process.env.REACT_APP_MAX_ATTEMPS,
  TEST_DOCUMENT_MIN: process.env.REACT_APP_TEST_DOCUMENT_MIN,
  TEST_DOCUMENT_MAX: process.env.REACT_APP_TEST_DOCUMENT_MAX,
  TEST_MAX_ATTEMPS: process.env.REACT_APP_TEST_MAX_ATTEMPS,
  TEST_DOCUMENT: process.env.REACT_APP_TEST_DOCUMENT,
  TEST_PROCESS_ID: process.env.REACT_APP_TEST_PROCESS_ID,
  TIME_SSOFUB: process.env.REACT_APP_TIME_SSOFUB,
  CUSTOMER_RESCUE: process.env.REACT_APP_CUSTOMER_RESCUE,
  TIME_OUT_REDIRECT: process.env.REACT_APP_TIME_OUT_REDIRECT
};
